module.exports = __webpack_public_path__ + "assets/img/shedule-link-professor.png";